import React, { Component } from 'react';
import { AccessToken } from './redux/reducers';
import {
  Card,
  Form,
  Row,
  Spin,
  Result,
  Divider,
  Col,
  Typography,
  Input,
  Button,
  List,
} from 'antd';
import { Invoice, Sale, Email, Permission, CompanyImages } from 'types/type';
import {
  CheckCircleFilled,
  FilePdfFilled,
  FileTextFilled,
} from '@ant-design/icons';
import { RootState } from 'store/configureStore';
import { getCompanyImages } from '../company/redux/actions';
import { getPermissions } from 'routes/users/redux/actions';
import { login } from './redux/actions';
import { downloadFile } from '../sales/redux/actions';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import logo from './../../assets/logo_login.png';
import { isAuthenticated } from 'security';
import SaleService from 'services/sale';
import { Popups } from 'commons/components/popups/popups';
import FiscalDataForm from './FiscalData/fiscalDataForm';
import { initInvoice } from 'commons/initTypes';
import { formatNumberToDisplay } from 'commons/functions';
import { FormComponentProps, WrappedFormUtils } from 'antd/lib/form/Form';
import { InvoiceRules as r } from './FiscalData/rulesFiscalData';
import { CloseCircleOutlined } from '@ant-design/icons';
import {
  saveInvoiceAndCancel,
  InvoiceActionConstructors,
  setScannedQR
} from 'routes/invoices/redux/actions';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import ScannerButton from 'routes/qr/ScannerButton';
import { Token, getToken, getDecodeToken } from '../../security';

const saleService = new SaleService();
const REDIRECT_FINISH = '/factura-finish';

interface DispatchProps {
  login: (username: string, password: string) => void;
  getCompanyImages: () => void;
  getPermissions: () => void;
  downloadFile: (
    id: string,
    name: string,
    saleFolio: string,
    showFile: boolean,
  ) => void;
}

interface StateProps {
  accessToken: AccessToken;
  readonly isFetching: boolean;
  companyImagesList: CompanyImages[];
  permissionList: Permission[];
}

type Props = DispatchProps &
  StateProps &
  FormComponentProps &
  InvoiceActionConstructors &
  RouteComponentProps;

class QrCode extends Component<Props> {
  public RFC_GENERAL = 'XAXX010101000';
  public state = {
    loading: true,
    sales: [],
    errorState: false,
    erroMessage: '',
    invoice: initInvoice,
    isSecure: true,
  };

  private iusCode?: string = undefined;
  private amount?: string = undefined;

  public componentDidMount(): void {
    const search = window.location.search;
    const queryParams = new URLSearchParams(search);
    this.iusCode = queryParams.get('iusCode') || undefined;
    this.amount = queryParams.get('amount') || undefined;

    if (!isEmpty(getToken())) {
      const token: Token = getDecodeToken();
      if(token.isClient){
        this.addScannedQR(search);
        this.props.history.push('/invoiceUser');
      }
    }

    this.props.getPermissions();
    this.props.getCompanyImages();
    
    this.chargeData(this.iusCode || '', this.amount || '');
  }

  public async addScannedQR(url: string) {
    await this.props.setScannedQR(url);
  }

  public async chargeData(iusCode: string, amount: string) {
    const amountNum = Number(amount);
    if (iusCode === '') {
      this.setState({
        loading: false,
        errorState: true,
        erroMessage: 'IUS inválido',
      });
      return;
    }
    if (isNaN(amountNum)) {
      this.setState({
        loading: false,
        errorState: true,
        erroMessage: 'Monto inválido',
      });
      return;
    }
    saleService
      .getbyiUSCodeandTotal(iusCode, amountNum)
      .then((response) => {
        this.setState({ sales: [...this.state.sales, response] });
      })
      .catch((e) => {
        this.setState({
          errorState: true,
          erroMessage: e.response.data.message,
        });
      })
      .finally(() => this.setState({ loading: false }));
  }

  private renderEmailForm = (): JSX.Element => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    return (
      <Form>
        <Col span={24}>
          <p style={{ marginTop: 20, marginBottom: 20 }}>
            Ingresa el correo electronico donde quieres que te enviemos la
            factura
          </p>
          <Card
            className={'card-invoice-content'}
            style={{
              backgroundColor: '#f1f7ff',
              margin: '0 auto',
              maxWidth: '30rem',
            }}
          >
            <Form.Item hasFeedback label="Correo Electrónico">
              {getFieldDecorator('email', {
                rules: r.emailRule,
              })(<Input size="large" placeholder="Correo electrónico" />)}
            </Form.Item>
          </Card>
        </Col>
      </Form>
    );
  };

  private createInvoice = async (
    salesStagingArea: Sale[],
    fields: Email,
    invoice: Invoice,
  ): Promise<void> => {
    const Invoice = {
      ...invoice,
      email: fields.email,
      sales: salesStagingArea,
      fiscalRegime: invoice.fiscalRegime,
    };
    await this.props.saveInvoiceAndCancel(Invoice);
    this.props.history.push(REDIRECT_FINISH);
  };

  private onRequestInvoice = (form: WrappedFormUtils<Invoice>): void => {
    form.validateFields(async (err, values: Invoice): Promise<void> => {
      if (err) {
        Promise.resolve();
      } else {
        this.setState({ invoice: { ...values } });
        const invoice = { ...values };
        this.props.form.validateFields(
          async (err, fields: Email): Promise<void> => {
            !Boolean(err?.email) &&
              Popups.executeOrNotifyError((): Promise<void> => {
                if (this.state.isSecure)
                  this.createInvoice(
                    this.state.sales.filter(
                      (s: Sale) =>
                        !s.billed ||
                        (s.billed && this.RFC_GENERAL.includes(s.invoiceRfc)),
                    ),
                    fields,
                    invoice,
                  );
                return Promise.resolve();
              });
          },
        );
      }
    });
  };

  renderCustomButton = (form: WrappedFormUtils<Invoice>): JSX.Element => (
    <Button
      type="primary"
      disabled={this.props.isFetching}
      onClick={() => this.onRequestInvoice(form)}
    >
      Facturar
    </Button>
  );

  public renderCancelButton = (): JSX.Element => (
    <Button type="ghost" onClick={() => (window.location.href = '/')}>
      Cancelar <CloseCircleOutlined />
    </Button>
  );

  public onContinueScanner = (sales: Sale[]) => {
    const existingIds = new Set(this.state.sales.map((s: Sale) => s.id));
    const newSales = sales.filter((s) => !existingIds.has(s.id));
    this.setState({ sales: [...this.state.sales, ...newSales] });
  };

  public render = (): JSX.Element => {
    const { isFetching, companyImagesList } = this.props;

    const { loading, errorState, erroMessage, sales } = this.state;

    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };

    const userIsAuthenticated = isAuthenticated();

    const loginImage = localStorage.getItem('bussisnesImage');
    if (companyImagesList.length > 0) {
      if ((companyImagesList[0] || {}).bussisnesImage !== null) {
        localStorage.setItem(
          'bussisnesImage',
          (companyImagesList[0] || {}).bussisnesImage,
        );
      }
      if ((companyImagesList[0] || {}).bussisnesLogo !== null) {
        localStorage.setItem(
          'bussisnesLogo',
          (companyImagesList[0] || {}).bussisnesLogo,
        );
      }
    }

    const imgStyle = {
      width: '100%',
      maxWidth: '200px',
      height: 'auto',
      display: 'block',
      margin: 'auto',
      objectFit: 'contain' as const,
      maxHeight: '15vh',
    };

    return (
      <Spin tip="Cargando..." spinning={loading}>
        {errorState ? (
          <Card
            style={{ margin: 'auto', maxWidth: '30rem', marginTop: '2rem' }}
          >
            <Row style={{ backgroundColor: '#f1f7ff' }}>
              <p />
              {isEmpty(loginImage) ? (
                <img style={imgStyle} src={logo} alt="company_logo" />
              ) : (
                <img
                  style={imgStyle}
                  alt="Logo"
                  src={'data:image/jpg;base64,' + loginImage}
                />
              )}
              <p />
            </Row>
            <Divider />
            <Row>
              <Result title={erroMessage} status={'error'} />
              <Col style={{ margin: '0 auto', textAlign: 'center' }}>
                <Link to="/">
                  <Button type="primary" className="button-invoice-serch-style">
                    Ir a Inicio
                  </Button>
                </Link>
              </Col>
            </Row>
          </Card>
        ) : (
          <Card
            style={{ margin: 'auto', maxWidth: '90rem', marginTop: '2rem' }}
          >
            <Row gutter={[30, 10]} type='flex'>
              <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                <Row style={{ backgroundColor: '#f1f7ff' }}>
                  {isEmpty(loginImage) ? (
                    <img style={imgStyle} src={logo} alt="company_logo" />
                  ) : (
                    <img
                      style={imgStyle}
                      alt="Logo"
                      src={'data:image/jpg;base64,' + loginImage}
                    />
                  )}
                </Row>
                <Divider />
                <Row>
                  <Col>
                    <Row
                      type="flex"
                      justify="space-between"
                      align='middle'
                    >
                      <Typography.Text strong>IUS a facturar</Typography.Text>
                      <ScannerButton onContinue={this.onContinueScanner}>
                        Leer QR
                      </ScannerButton>
                    </Row>
                    <List
                      loading={loading}
                      size="small"
                      style={{ borderRadius: 5 }}
                      dataSource={sales}
                      pagination={{
                        pageSize: 5,
                        position: 'bottom',
                        size: 'small',
                      }}
                      renderItem={(s: Sale) => (
                        <List.Item style={{ borderBottom: 'none' }}>
                          <Card
                            key={s.id}
                            type="inner"
                            size="small"
                            title={
                              <Row type="flex" justify="space-between">
                                <Typography.Text
                                  strong
                                  style={{ fontSize: 'clamp(0.8rem, 1.5rem)' }}
                                >
                                  {new Date(s.endDate).toLocaleDateString(
                                    undefined,
                                    options,
                                  )}
                                </Typography.Text>
                                {s.billed &&
                                !this.RFC_GENERAL.includes(s.invoiceRfc) ? (
                                  <div style={{ color: '#52c41a' }}>
                                    <CheckCircleFilled /> Facturada{' '}
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </Row>
                            }
                            style={{
                              width: '100%',
                              minWidth: 200,
                              borderRadius: '5px',
                              overflow: 'hidden',
                            }}
                          >
                            <Row>
                              <Col span={20}>
                                <Typography.Paragraph
                                  style={{
                                    fontSize:
                                      'clamp(0.78rem, 1vw + 0.3rem, 0.9rem)',
                                  }}
                                >
                                  {s.IUSCode}
                                </Typography.Paragraph>
                                <Typography.Text
                                  strong
                                  style={{ color: '#52c41a' }}
                                >
                                  $ {formatNumberToDisplay(s.total)}&emsp;
                                </Typography.Text>
                                <Typography.Text strong>
                                  {formatNumberToDisplay(s.totalVolume, 3)}{' '}
                                  litros
                                </Typography.Text>
                              </Col>
                              <Col span={4}>
                                {s.billed &&
                                  !this.RFC_GENERAL.includes(s.invoiceRfc) && (
                                    <Row>
                                      <Col span={24} style={{display:'flex', placeContent:'end'}}>
                                        <Button
                                          size="small"
                                          className="link-button"
                                          onClick={() =>
                                            this.props.downloadFile(
                                              s.id,
                                              'file.pdf',
                                              s.IUSCode,
                                              false,
                                            )
                                          }
                                        >
                                          <FilePdfFilled />
                                          PDF
                                        </Button>
                                      </Col>
                                      <Col span={24} style={{display:'flex', placeContent:'space-around end'}}>
                                        <Button
                                          size="small"
                                          className="link-button"
                                          onClickCapture={() =>
                                            this.props.downloadFile(
                                              s.id,
                                              'file.xml',
                                              s.IUSCode,
                                              false,
                                            )
                                          }
                                        >
                                          <FileTextFilled />
                                          XML
                                        </Button>
                                      </Col>
                                    </Row>
                                  )}
                              </Col>
                            </Row>
                          </Card>
                        </List.Item>
                      )}
                    ></List>
                  </Col>
                </Row>
              </Col>
              <Col xs={0} sm={0} md={0} lg={1} xl={1}>
                <div className="vertical-divider" />
              </Col>
              <Col xs={24} sm={24} md={24} lg={0} xl={0}>
                <Divider />
              </Col>
              <Col xs={24} sm={24} md={24} lg={15} xl={15}>
                  <FiscalDataForm
                    showFiscalDataProvidedNext={false}
                    showFiscalDataProvidedPrev={false}
                    renderCancelButton={this.renderCancelButton}
                    isFetching={this.props.isFetching}
                    invoice={this.state.invoice}
                    customChildren={this.renderEmailForm}
                    customButton={this.renderCustomButton}
                  />
              </Col>
            </Row>
          </Card>
        )}
      </Spin>
    );
  };
}

const mapStateToProps = (states: RootState): StateProps => {
  return {
    accessToken: states.loginState.accessToken,
    isFetching: states.invoiceState.isFetching,
    companyImagesList: states.companyState.companyImagesList,
    permissionList: states.usersState.permissionList,
  };
};

/**
 * Maps the possible actions that can be executed in this component.
 */
const mapDispatchToProps = {
  login,
  getCompanyImages,
  getPermissions,
  saveInvoiceAndCancel,
  downloadFile,
  setScannedQR,
};

export default connect<StateProps, DispatchProps, {}, RootState>(
  mapStateToProps,
  mapDispatchToProps,
)(Form.create()(QrCode));
